import { useState } from 'react';

import useToggle from '@/data/hook/useToggle';
import { Nullable } from '@/models/Model';

export type AnswerMode = 'text' | 'media';

type UseAnswerModeArgs = {
  mediaFile?: Nullable<File | string>;
  mediaLink?: Nullable<string>;
  initialEditing?: boolean;
};

export function useAnswerMode({
  mediaFile,
  mediaLink,
  initialEditing = false,
}: UseAnswerModeArgs) {
  const [mode, setMode] = useState<AnswerMode>(
    mediaFile || mediaLink ? 'media' : 'text',
  );
  const {
    isOpen: isEditing,
    open: handleStartEdit,
    close: handleFinishEdit,
  } = useToggle(initialEditing);

  const handleSwitchToMedia = () => {
    setMode('media');
    handleStartEdit();
  };

  const handleSwitchToText = () => {
    setMode('text');
    handleStartEdit();
  };

  return {
    mode,
    isEditing,
    handleSwitchToMedia,
    handleSwitchToText,
    handleStartEdit,
    handleFinishEdit,
  };
}
